import React from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import About from '../About/About';
import Contacts from '../Contacts/Contacts';
import Rate from '../Rate/Rate';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import Popup from '../Popup/Popup';
import Other from '../Other/Other';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navLink: {
        main: '/',
        about: '/about',
        contacts: '/contacts'
      },
    };
  }

  render() {
    return (
      <div className="App">
        <Router>
          <Header link={this.state.navLink} />

          <div className="container">
            <main>
              <Switch>
                <Route exact path={this.state.navLink['main']} component={Rate} />
                <Route exact path={this.state.navLink['about']} component={About} />
                <Route exact path={this.state.navLink['contacts']} component={Contacts} />
                <Route component={Other} />
              </Switch>
            </main>
          </div>

          <div className='container' id="cookie_info">
            <Popup />
          </div>
          <Footer link={this.state.navLink} />
        </Router>
      </div >
    );
  }
}

export default App;
